import React, { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Box, useMediaQuery } from '@mui/material';
import useAppStyle from './styles/AppStyles.jsx';

import SiteHeader from './components/SiteHeader.jsx';
import SiteFooter from './components/SiteFooter.jsx';
import HomePage from './components/HomePage.jsx';
import About from './components/About/About.jsx';
import Portfolio from './components/Portfolio/Portfolio.jsx';
import Gallery from './components/Gallery/Gallery.jsx';

function App() {
  const { pathname } = useLocation();
  const isPad = useMediaQuery('(max-width:1300px)');
  const isMobile = useMediaQuery('(max-width:700px)');
  const isHomePage = pathname === '/' || pathname === '';
  const {
    root,
    rootDark,
    layer,
    layerDark,
    otherPage,
    otherPageDark,
    otherPageLayer,
    otherPageLayerDark,
    pageContainer,
    pageContainerMobile,
  } = useAppStyle();

  const themes = ['light', 'dark'];
  const [theme, setTheme] = useState('light');

  const toggleTheme = () => {
    setTheme(prev => themes.filter(t => t !== prev)[0]);
  };

  let appClass = '';
  let layerClass = '';

  if (isHomePage) {
    if (theme === 'light') {
      appClass = root;
      layerClass = layer;
    } else {
      appClass = `${root} ${rootDark}`;
      layerClass = `${layer} ${layerDark}`;
    }
  } else if (theme === 'light') {
    appClass = `${root} ${otherPage}`;
    layerClass = `${layer} ${otherPageLayer}`;
  } else {
    appClass = `${root} ${otherPage} ${otherPageDark}`;
    layerClass = `${layer} ${otherPageLayer} ${otherPageLayerDark}`;
  }

  return (
    <Box className={appClass}>
      <Box className={layerClass} />
      <Box className={(!isMobile && !isPad) ? pageContainer : `${pageContainer} ${pageContainerMobile}`}>
        <SiteHeader toggleTheme={toggleTheme} theme={theme} isMobile={isPad} />
        <Routes>
          <Route path='/' element={<HomePage isMobile={isPad} />} />
          <Route path='about' element={<About isMobile={isMobile} />} />
          <Route path='portfolio' element={<Portfolio theme={theme} isMobile={isMobile} />} />
          <Route path='gallery' element={<Gallery theme={theme} isMobile={isMobile} />} />
        </Routes>
        <SiteFooter isMobile={isMobile} />
      </Box>
    </Box>
  );
}

export default App;
